import React, { memo, useRef, useEffect } from 'react';
import '../assets/css/Header.css';
import { useHeader } from '../hooks/useHeader';
import logo from '../assets/images/logo.png';

const NAV_ITEMS = [
  { id: 'home', label: 'Home' },
  { id: 'services', label: 'Services' },
  { id: 'projects', label: 'Projects' },
  { id: 'about', label: 'About' },
  { id: 'contact', label: 'Contact' }
];

function Header() {
  const { menuOpen, toggleMenu, activeSection, scrollToSection } = useHeader();
  const navRef = useRef(null);
  const underlineRef = useRef(null);

  useEffect(() => {
    const navItems = navRef.current?.querySelectorAll('.nav-item');
    const currentItem = Array.from(navItems).find(
      (el) => el.dataset.id === activeSection
    );
    if (currentItem && underlineRef.current) {
      underlineRef.current.style.width = `${currentItem.offsetWidth}px`;
      underlineRef.current.style.left = `${currentItem.offsetLeft}px`;
    }
  }, [activeSection]);

  return (
    <header className="header">
      <div className="container main-header">
        <div className="header-content">
          <div className="logo-wrapper">
            <img src={logo} alt="MECONSTEEL88 CO." className="logo-img" />
            <div className="company-title">
              <h1 className="company-name">MECONSTEEL88 CO.</h1>
              <p className="tagline">WE TURN VISIONS INTO STRUCTURES</p>
            </div>
          </div>
        </div>
        <button
          className="menu-toggle"
          onClick={toggleMenu}
          aria-expanded={menuOpen}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
        <nav className={`nav ${menuOpen ? 'open' : ''}`} ref={navRef}>
          <ul className="nav-list">
            {NAV_ITEMS.map((item) => (
              <li key={item.id}>
                <button
                  className="nav-item"
                  data-id={item.id}
                  onClick={() => scrollToSection(item.id)}
                >
                  {item.label}
                </button>
              </li>
            ))}
            <span className="nav-underline" ref={underlineRef}></span>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default memo(Header);
